import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";

export const AuthCard = ({ eyebrow, title, children, testId }) => (
  <div className="relative z-10 min-h-screen flex items-center justify-center px-6 py-16 bg-background">
    <div className="w-full max-w-md fade-up" data-testid={testId}>
      <Link to="/" className="flex items-center gap-3 mb-12" data-testid="auth-card-brand"><img src={BRAND.leaf} alt="" className="h-7 w-7" /><span className="font-serif text-xl text-navy">{BRAND.name}</span></Link>
      <div className="eyebrow mb-3">{eyebrow}</div>
      <h1 className="text-3xl sm:text-4xl text-navy mb-6">{title}</h1>
      {children}
      <p className="mt-8 text-sm text-muted-foreground text-center"><Link to="/login" className="text-pinkb hover:underline" data-testid="auth-card-login-link">Back to log in</Link></p>
    </div>
  </div>
);
